import { Stepper as MantineStepper, StepperProps as MantineStepperProps } from "@mantine/core";
import { ReactNode } from "react";

interface StepperProps extends MantineStepperProps {
  children: ReactNode;
}

const Stepper = ({ children, ...props }: StepperProps) => {
  return (
    <>
      <MantineStepper
        {...props}
        style={{
          stepLabel: {
            fontWeight: 400,
          },
        }}
      >
        {children}
      </MantineStepper>
    </>
  );
};

export default Stepper;

Stepper.Step = MantineStepper.Step;
